import { Injectable, ErrorHandler } from '@angular/core';
import { RemoteLoggingService } from './remote-logging.service';

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  constructor(public log: RemoteLoggingService) {}

  handleError(error) {
    // console.error(error.message);
    console.error(error.stack);
    this.log.write(error.stack);
  }
}
